import { render, staticRenderFns } from "./MailsView.vue?vue&type=template&id=fdae2d40"
import script from "./MailsView.vue?vue&type=script&lang=js"
export * from "./MailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports